import React from 'react';

const SubscriptionHome = () => {
  return (<div>
    <h1>Subscription Home</h1>
  </div>)
}

export default SubscriptionHome